export function useWeeklyHoursSummary(_a) {
    var totalDuration = _a.totalDuration, workedDuration = _a.workedDuration, scheduledDuration = _a.scheduledDuration;
    var totalHours = totalDuration
        ? totalDuration.as('hours').toFixed(1)
        : '0';
    var workedHours = workedDuration
        ? workedDuration.as('hours').toFixed(1)
        : '0';
    var scheduledHours = scheduledDuration
        ? scheduledDuration.as('hours').toFixed(1)
        : '0';
    return {
        totalHours: totalHours,
        workedHours: workedHours,
        scheduledHours: scheduledHours
    };
}
